import _cloneDeep from 'lodash/cloneDeep';

/**
 * RemoteConfig class.
 * Use this service to manage configuration from API/Server.
 */
export default class RemoteConfig {
    /**
     * @param {ConfigApi} ConfigApi - Configuration API service
     * @constructor
     * @ngInject
     */
    constructor(ConfigApi) {
        this.api = ConfigApi;
        this.config = null;
        this.partner = null;
        this.things = null;
        this.notifications = null;
        this.services = null;
        this.errors = null;
    }

    /**
     * Load configuration
     * @returns {Object} Return configuration object
     */
    loadConfig() {
        return this
            .api
            .getConfig()
            .then((config) => {
                this.config = config;

                this.parseConfig();

                return config;
            });
    }

    /**
     * Parse loaded configuration for partials
     */
    parseConfig() {
        if (!this.config || !Object.keys(this.config).length) return;

        this
            .initPartnerConfig()
            .initThingsConfig()
            .initNotificationsConfig()
            .initErrorsConfig()
            .initServicesConfig();
    }

    /**
     * Initialize Partner configuration
     * @returns {RemoteConfig}
     */
    initPartnerConfig() {
        if (this.config.partner) this.partner = _cloneDeep(this.config.partner);

        return this;
    }

    /**
     * Initialize Things configuration
     * @returns {RemoteConfig}
     */
    initThingsConfig() {
        if (this.config.things) this.things = _cloneDeep(this.config.things);

        return this;
    }

    /**
     * Initialize Notifications configuration
     * @returns {RemoteConfig}
     */
    initNotificationsConfig() {
        if (this.config.notifications) this.notifications = _cloneDeep(this.config.notifications);

        return this;
    }

    /**
     * Initialize Errors configuration
     * @returns {RemoteConfig}
     */
    initErrorsConfig() {
        if (this.config.errors) this.errors = _cloneDeep(this.config.errors);

        return this;
    }

    /**
     * Initialize Services configuration
     * @returns {RemoteConfig}
     */
    initServicesConfig() {
        if (this.config.services) this.services = _cloneDeep(this.config.services);

        return this;
    }

    /**
     * Get Partner configuration
     * @returns {null|object}
     */
    getParnerConfig() {
        return this.partner;
    }

    /**
     * Get Things configuration
     * @returns {null|object}
     */
    getThingsConfig() {
        return this.things;
    }

    /**
     * Get Notifications configuration
     * @returns {null|object}
     */
    getNotificationsConfig() {
        return this.notifications;
    }

    /**
     * Get Errors configuration
     * @returns {null|object}
     */
    getErrorsConfig() {
        return this.errors;
    }

    /**
     * Get Services configuration
     * @returns {null|object}
     */
    getServicesConfig() {
        return this.services;
    }

    /**
     * Get Service configuration by service name
     * @returns {Object} Return service configuration by service name or empty object if absent
     */
    getServiceConfig(serviceName) {
        return this.services[serviceName] || {};
    }
}



// WEBPACK FOOTER //
// ./app/services/config/remote/remote.service.js